<template>
  <div class="flex flex-col items-center m-5 text-white">
    <div class="mt-20">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus-circle" class="w-32 h-32" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          fill="currentColor"
          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
        ></path>
      </svg>
    </div>
    <div class="mt-5 font-bold">
      NO PODEMOS DETERMINAR SI usted se encuentra dentro de la jurisdicción autorizada para utilizar esta app.
    </div>
    <div class="mt-5 text-sm">
      Por cuestiones LEGALES no puede utilizar la plataforma desde su ubicación actual
    </div>
    <div>
      <button>
        <button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Entrar</button>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    inicio() {
      this.$router.push("/menu");
    }
  }
};
</script>
